"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TabList_1 = require("../TabList");
var helpers_1 = require("../helpers");
var isCustomItem = function (item) {
    return item.render !== undefined;
};
exports.PageWizardTabs = helpers_1.createUIElement('PageWizardTabs', function (_a, ref) {
    var className = _a.className, tabs = _a.tabs, width = _a.width, tooltipMaxWidth = _a.tooltipMaxWidth, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "tabs", "width", "tooltipMaxWidth", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (react_1.default.createElement(TabList_1.TabList, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'pagewizard-tabs', className: "vm-PageWizardTabs " + className, backgroundView: TabList_1.TAB_LIST_BACKGROUND_VIEW.normal, items: tabs.map(function (item, idx) {
            var baseItemProps = {
                id: idx.toString(),
                active: item.active,
                disabled: item.disabled,
                onClick: !item.disabled ? item.onClick : undefined
            };
            if (isCustomItem(item)) {
                return __assign(__assign({}, baseItemProps), { render: item.render });
            }
            return __assign(__assign({}, baseItemProps), { title: item.title });
        }), width: width, tooltipMaxWidth: tooltipMaxWidth, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style })));
});
//# sourceMappingURL=PageWizardTabs.js.map